import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { format } from "date-fns";
import Constants from "../Utilities/Constants";


const DeliverySelect = ({data, setData, setComponent}) => { 
    const [ selectedDate, setSelectedDate] = useState('');
    const [ selectedDay, setSelectedDay] = useState('');
    const [ selectedTime, setSelectedTime] = useState('');
    const [ windows, setWindows ] = useState([]);
    const currentDate = useRef('');

    useEffect(() => {
        const yishuvId = data.pickup ? 0 : (data.yishuvId ?? 0);
        const url = `${Constants.API_URL_GET_DELIVERY_WINDOWS}/${yishuvId}?pickup=${data.pickup ? 'true' : 'false'}`;

        const fetchDeliveryWindows = async () => {
            try {
                const response = await axios.get(url);
                setWindows(response.data);
            }
            catch (error) {
                console.error(error);
            }
        }

        const Initialize = async () => {
            setSelectedDate(data.deliveryDate); 
            setSelectedTime(data.deliveryTime); 
            setSelectedDay(data.deliveryDay);
        }

        Initialize();
        fetchDeliveryWindows();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = (window) => {
        setSelectedDate(window.date); 
        setSelectedTime(window.fromTime.substring(0,5) +'-'+window.toTime.substring(0,5)); 
        setSelectedDay(window.day);

        setData(values => ({...values, 
            deliveryDate: window.date,
            deliveryTime: window.fromTime.substring(0,5),
            deliveryDay: window.day,
            pickup: window.pickup
        }));

        setComponent('VerifyStock');    
    }

    const DeliveryButton = ({window}) => {

        return (
            <button className={window.pickup ? 'btn btn-secondary m-2' : 'btn btn-success m-2'} onClick={() => handleClick(window)}>
                {window.fromTime.substring(0,5)} - {window.toTime.substring(0,5)}
            </button> 
        )
    }


    return (
        <>
            <div className="d-flex justify-content-between border-bottom border-success">
                <h4 className="">בחר יום ושעה מועדפים ל{data.pickup ? 'איסוף' : 'משלוח'}</h4>
                <h4>
                    <button className="align-left" title="חזור" onClick={()=>setComponent('DeliveryAddress')} >{'<<'}</button>
                    {data.deliveryDate &&
                        <button className="align-left" title="הבא" onClick={()=>setComponent('VerifyStock')} >{'>>'}</button>}
                </h4>
            </div>

            {/* First day */}
            <div className="fw-bold text-success">
                {selectedDate && 
                    <span>יום {selectedDay} {format(selectedDate,'dd/MM/yyy')}, {selectedTime}</span>
                }
            </div>
            
            {windows.map((window, index) => {
                if (currentDate.current === window.date) {
                    return (
                        <DeliveryButton window={window} />
                    )
                } else {
                    currentDate.current = window.date;
                    return (
                        <>
                        <div key={index} >
                            <div className="mt-4 p-1"> 
                                <span>יום {window.day} {format(window.date,'dd/MM/yyy')}</span>
                            </div>
                        </div>
                        <DeliveryButton window={window} />
                        </>
                    )
                }
            })}
            
            <br />
            <br />
        </>
    )
}

export default DeliverySelect;